import { css } from '@emotion/react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import Text from '../../OC/PageBuilder/utilities/Text';

const defaultStyle = css`
  font-family: OCRoboto, sans-serif;
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
  color: #000000;
  width: 100%;
`;

const Description = styled.p`
  ${defaultStyle};
  text-wrap: wrap;
  white-space: break-spaces;
  margin-top: 5px;
`;

const ColorSelectedCopy = styled.p`
  ${defaultStyle};
  margin-top: -25px;
  margin-bottom: 0;
`;

const ColorName = styled.h3`
  font-family: OCRoboto, sans-serif;
  font-size: 24px;
  line-height: 24px;
  font-weight: 700;
  margin-bottom: 10px;
  text-transform: capitalize;
`;

const ShingleColorDescription = ({ name, description, className }) => {
  if (!description) {
    return null;
  }

  return (
    <>
      {name && (
        <div className="mobile-only">
          <ColorSelectedCopy>Color Selected:</ColorSelectedCopy>
          <ColorName>{name}</ColorName>
        </div>
      )}
      <Description className={className}>
        <Text content={description} />
      </Description>
    </>
  );
};

export default ShingleColorDescription;

ShingleColorDescription.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
};

ShingleColorDescription.defaultProps = {
  name: null,
  description: null,
  className: '',
};
